<template>
  <div
    ref="modal"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="staticBackdropLabel">
            {{ $t("editOrderProductsModal.editOrderProducts") }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            :aria-label="$t(`confirmModal.close`)"
          ></button>
        </div>
        <div class="modal-body">
          <div
            class="row text-start custom-input whitebg-input align-items-center"
            v-for="item in value"
            :key="item.id"
          >
            <div class="col-4">
              <div class="semibold-16">{{ item.serial }}</div>
              <div>{{ item.sku ?? item.ean }}</div>
            </div>
            <div class="col-4">
              {{ item.name }}
              <div>
                <span v-for="c in item.caracteristics" :key="c" class="me-1">
                  {{ c }}
                </span>
              </div>
            </div>
            <div class="col-4">
              <div class="fix-end-input">
                <input
                  type="number"
                  class="form-control"
                  min="0"
                  v-model="item.payed_price.amount"
                />
                <span>
                  {{ item.payed_price.currency }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" v-on:click="save">
            {{ $t("finance.save") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const bootstrap = require("bootstrap");

export default {
  name: "EditOrderProductsModal",
  props: {
    modelValue: Object,
  },
  data() {
    return {
      value: this.modelValue,
      max: null,
    };
  },
  watch: {
    modelValue() {
      this.value = this.modelValue;
    },
  },
  methods: {
    showModal() {
      if (this.myModal === undefined) {
        this.myModal = new bootstrap.Modal(this.$refs.modal, {
          backdrop: "static",
        });
      }
      this.myModal.show();
    },
    save() {
      this.$emit("change", this.value);
      this.myModal.hide();
    },
  },
  emits: ["update:modelValue", "change"],
};
</script>
